import { createReducer } from "@reduxjs/toolkit";
import {
  CATEGORY_VALUES_LOADING,
  CATEGORY_VALUES_ERROR,
  GET_CATEGORY_VALUES,
} from "../actions/types";

const initialState = {
  error: "",
  loading: false,
  data: [],
};

const categoryValuesReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(CATEGORY_VALUES_LOADING, (state) => {
      state.loading = true;
    })
    .addCase(CATEGORY_VALUES_ERROR, (state, { payload }) => {
      state.error = payload;
      state.loading = false;
    })
    .addCase(GET_CATEGORY_VALUES, (state, { payload }) => {
      state.data = payload;
      state.loading = false;
    });
});

export default categoryValuesReducer;
